document.addEventListener("DOMContentLoaded", function () {
    const menuTrigger = document.getElementById("owd-menu-trigger");
    const mainNavHeader = document.getElementById("owd-primary-navigation");

    if (!menuTrigger) return;

    // Helper function to close the menu drawer and restore body scroll
    function closeMenu() {
        menuTrigger.classList.remove("is-active");
        menuTrigger.setAttribute("aria-expanded", "false");

        if (mainNavHeader) {
            mainNavHeader.classList.remove("nav-menu--open");
            mainNavHeader.setAttribute("aria-hidden", "true");
            document.body.classList.remove("body-lock");
        }
    }

    // Toggle menu state on trigger click
    menuTrigger.addEventListener("click", function () {
        const isActive = menuTrigger.classList.toggle("is-active");
        menuTrigger.setAttribute("aria-expanded", isActive ? "true" : "false");

        if (mainNavHeader) {
            mainNavHeader.classList.toggle("nav-menu--open", isActive);
            mainNavHeader.setAttribute("aria-hidden", isActive ? "false" : "true");
            document.body.classList.toggle("body-lock", isActive);
        }
    });

    // Close menu when clicking any anchor link (#example) inside the navigation
    if (mainNavHeader) {
        const navAnchorLinks = mainNavHeader.querySelectorAll('a[href*="#"]');

        navAnchorLinks.forEach(function (link) {
            link.addEventListener("click", function () {
                // Only close if it's an internal anchor or page jump
                closeMenu();
            });
        });
    }
});
